export default "__VITE_ASSET__OwQbA8$x__"